<template>
  <Tab
    :class="classes"
    :value="tab"
    data-sb-regression="sb-tab"
    @click.stop="handleSetActiveTab"
  >
    <slot />
  </Tab>
</template>

<script setup>
/* eslint-disable css-modules/no-unused-class */
import Tab from 'primevue/tab';
import { computed, defineProps, inject, defineOptions, useCssModule } from 'vue';
import { isEqual } from 'lodash';

const $style = useCssModule();
defineOptions({
  name: 'SbTabNext',
});

const setActiveTab = inject('setActiveTab');
const sbTabs = inject('sbTabs');

const props = defineProps({
  /**
     * Model of the tab that will be the `v-model` value of the SbTabs component when this tab is active.
     */
  tab: {
    default: null,
    type: [String, Number, Object],
  },

  /**
     * Flag used to apply a vertical separator to the left of this tab.
     */
  delimit: {
    type: Boolean,
    default: false,
  },
  /**
     * If the tab is disabled or not
     */
  disabled: {
    type: Boolean,
    default: false,
  },
});

const active = computed(() => {
  return props.tab !== null && isEqual(sbTabs?.activeTab, props.tab);
});

const classes = computed(() => {
  if (props.disabled) return [$style['sbTab--disabled']];
  const array = [$style.sbTab];
  if (active.value) array.push($style.sbTabActive);
  if (props.delimit) array.push($style.sbTabDelimiter);
  return array;
});

function handleSetActiveTab() {
  setActiveTab(props.tab);
}

</script>
<style lang="scss" module>
@use '@src/components/Tabs/style/sb-tab.module.scss';
</style>
